import { config } from '../../../../definitions/TimelineItems';
import TimelineItem from '../TimelineItem';

import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import {getLogo} from "../../../../utils/LogoUtils";
import {
  getDepartmentDisplay,
  getDepartmentabbreviation
} from '../../../../utils/TimelineUtils';
let { id: module_id } = module;

const HospitalWardTimelineItem = ({ data, intl, linkkipalvelu }) => {
  const hospitalWardConfig = {
    ...config[data.type],
    title: {
      message: `${module_id}.title`,
    },
    icon: {
      type: 'custom',
      name: 'hospitalWard',
    },
    color: 'blue',
  };

  let unitLogo = null;
  const logoFromLinkkipalvelu =
    linkkipalvelu.Logot && linkkipalvelu.Logot[data.oid];

  if (
    logoFromLinkkipalvelu &&
    logoFromLinkkipalvelu !== 'fetching' &&
    logoFromLinkkipalvelu !== 'error' &&
    logoFromLinkkipalvelu[0] !== null
  ) {
    const logoAttr = getLogo(logoFromLinkkipalvelu[0].toString());
    if(logoAttr) {
      unitLogo = (
        <img
          className="card-logo_image"
          alt={intl.formatMessage({ id: logoAttr.altTextId })}
          src={logoAttr.logoSrc}
        />
      );
    }
  }

  let departmentToDisplay = chooseDepartmentDisplayStyle(data.department);

  return (
    <TimelineItem
      {...hospitalWardConfig}
      data={data}
      date={data.date}
      logo={unitLogo}
      contentDescription={
        <span>
          <FormattedMessage
            id={`${module_id}.description`}
            values={{
              department: <>{departmentToDisplay}</>,
            }}
          />
        </span>
      }
    />
  );
};

/**
 * If the department is for sydansairaala, show only department without abbreviation eg. without (SDPOSA) in the end.
 *
 * @param department eg. Toimenpideosasto (SDPOSA)
 * @returns {*}
 */
function chooseDepartmentDisplayStyle(department) {
  let abbreviation = getDepartmentabbreviation(department);
  if (abbreviation === "SDPOSA" || abbreviation === "SDOSA3") {
    let departmentWithoutAbbreviation = getDepartmentDisplay(department);
    return departmentWithoutAbbreviation.trimEnd();
  }
  return department;
}

export default injectIntl(HospitalWardTimelineItem);
